import { useState, useEffect } from "react";
import { updateInventoryBatchExpiration } from "../../../server/InventoryUpdate";

const ProductLocationTable = ({
  locations,
  generalZones,
  selectedRow,
  hasReturn,
  handleRowClick,
}) => {
  useEffect(() => {
    setLocationsRows(locations);
  }, [locations]);

  const [locationsRows, setLocationsRows] = useState(locations);
  const [editingCell, setEditingCell] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [isLoading] = useState(false);
  const explanations = ["טור", "מדף", "תא"];

  const startEditing = (locationId, currentDate, event) => {
    event.stopPropagation();
    setEditingCell(locationId);
    const dateValue = currentDate
      ? new Date(currentDate).toISOString().split("T")[0]
      : "";
    setEditValue(dateValue);
  };

  const cancelEditing = (event) => {
    event.stopPropagation();
    setEditingCell(null);
    setEditValue("");
  };

  const saveDate = (locationId, event) => {
    event.stopPropagation();

    if (!editValue) {
      cancelEditing(event);
      return;
    }

    const data = {
      id: locationId,
      expired: editValue,
    };

    updateInventoryBatchExpiration(locationId, editValue)
      .then((res) => {
        setEditingCell(null);
        setEditValue("");
        setLocationsRows(
          locationsRows.map((loc) =>
            loc.batchId === locationId
              ? { ...loc, expiration: editValue }
              : loc,
          ),
        );
      })
      .catch((error) => {
        console.error("error update expired: ", error);
      });
  };

  const handleKeyPress = (event, locationId) => {
    event.stopPropagation();

    if (event.key === "Enter") {
      saveDate(locationId, event);
    } else if (event.key === "Escape") {
      cancelEditing(event);
    }
  };

  const getGeneralZoneStatus = (zoneId) => {
    return generalZones?.find((z) => z.id === zoneId)?.status || "-";
  };

  return (
    <div className="product-location-table">
      <table>
        <tbody>
          <tr>
            <th>מיקום</th>
            <th>כמות</th>
            <th>כמות זמינה</th>
            <th>תוקף</th>
            <th>מצב מלאי</th>
          </tr>
          {locationsRows.length ? (
            locationsRows.map((x) => (
              <tr
                className={
                  selectedRow?.id === x.id
                    ? "location-row active"
                    : "location-row"
                }
                key={x.id}
                onClick={() => handleRowClick(x)}
              >
                <td>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                      {x.zoneName}
                    </div>
                    {x.spotId
                      ?.split("-")
                      .slice(1)
                      .map((part, index) =>
                        explanations[index] ? (
                          <div key={index}>
                            {explanations[index]}: {part.trim()}
                          </div>
                        ) : null,
                      )}
                  </div>
                </td>
                <td>{x.quantity}</td>
                <td>{x.quantity}</td>
                <td className="date-cell">
                  {editingCell === x.id ? (
                    <div
                      className="date-edit-container"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        onKeyDown={(e) => handleKeyPress(e, x.id)}
                        className="date-input"
                        disabled={isLoading}
                        autoFocus
                      />
                      <div className="date-actions">
                        <button
                          onClick={(e) => saveDate(x.batchId, e)}
                          disabled={isLoading}
                          className="save-btn"
                          title="שמור"
                        >
                          ✓
                        </button>
                        <button
                          onClick={cancelEditing}
                          disabled={isLoading}
                          className="cancel-btn"
                          title="ביטול"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  ) : (
                    <span
                      className="date-display"
                      onClick={(e) => startEditing(x.id, x.expiration, e)}
                      title="לחץ לעריכה"
                    >
                      {x.expiration
                        ? new Date(x.expiration).toLocaleDateString("en-GB")
                        : "-"}
                    </span>
                  )}
                </td>
                <td>{getGeneralZoneStatus(x.zoneId)}</td>
              </tr>
            ))
          ) : hasReturn ? (
            <tr>
              <td colSpan="5">לא נמצאו מיקומים במלאי</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default ProductLocationTable;
